import { Link } from '@tanstack/react-router';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '~/components/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle
} from '~/components/ui/empty';

interface Props {
  error: Error;
  reset: () => void;
}

export function ErrorScreen({ error: _error, reset }: Props): React.ReactNode {
  const { t } = useTranslation();

  return (
    <Empty className="border-0 py-12">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <AlertTriangle />
        </EmptyMedia>
        <EmptyTitle>{t('error.title')}</EmptyTitle>
        <EmptyDescription>{t('error.description')}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent className="flex-row justify-center">
        <Button onClick={reset}>{t('error.tryAgain')}</Button>
        <Button variant="outline">
          <Link to="/jobs">{t('error.goHome')}</Link>
        </Button>
      </EmptyContent>
    </Empty>
  );
}
